import { render, staticRenderFns } from "./excellentRecognition.vue?vue&type=template&id=e98c7e56&scoped=true&"
import script from "./excellentRecognition.vue?vue&type=script&lang=js&"
export * from "./excellentRecognition.vue?vue&type=script&lang=js&"
import style0 from "./excellentRecognition.vue?vue&type=style&index=0&id=e98c7e56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98c7e56",
  null
  
)

export default component.exports